import React from 'react';
import { Route } from "react-router-dom";
import AppLogout from '../../common/isLogout';
import { PrivateRoute } from '../../common/PrivateRoutes';
import PgmlistThreeWheeler from '../../Pages/PgmlistThreeWheeler';
import QueryThreeWheelers from '../../Pages/QueryThreeWheelers';
import ViewQueryThreeWheelers from '../../Pages/ViewQueryThreeWheelers';
import PgmDetailsThreeWheeler from '../../Pages/PgmDetailsThreeWheeler';
import DashboardLayout from '../../Layouts/DashboardLayouts';

const PgmRoutes = () => (
    <>
        {/* Pgm List ThreeWheeler */}
        <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
            <Route exact path="/3w/pgmdetails/:id" element={<AppLogout><PrivateRoute><PgmDetailsThreeWheeler /></PrivateRoute></AppLogout>} />
            <Route exact path="/3w/pgmlist" element={<AppLogout><PrivateRoute><PgmlistThreeWheeler /></PrivateRoute></AppLogout>} />
        </Route>

    </>
);

export default PgmRoutes;